import { render, staticRenderFns } from "./RoleModal.vue?vue&type=template&id=7ea3aee2&scoped=true&"
import script from "./RoleModal.vue?vue&type=script&lang=js&"
export * from "./RoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea3aee2",
  null
  
)

export default component.exports